export const normalizeValue = (raw) => (raw || '').trim();

/**
 * What a save should do given the current input and the stored row. Clearing a populated field
 * deletes the row; an empty field with nothing stored is a no-op, as is an unchanged value.
 * @param {{ value: string, existing?: object }} args raw input value and the stored
 * external_identifiers row, if any
 * @returns {{ action: 'upsert' | 'delete' | 'noop', value: string }}
 */
export const resolveSaveAction = ({ value, existing }) => {
    const normalized = normalizeValue(value);
    const stored = normalizeValue(existing?.value);

    if (normalized === stored) return { action: 'noop', value: normalized };
    if (!normalized) return { action: existing?.id ? 'delete' : 'noop', value: '' };
    return { action: 'upsert', value: normalized };
};

/**
 * Insert input for UPSERT_EXTERNAL_IDENTIFIER. `label` is always set — the column is NOT NULL and
 * is in the on_conflict update_columns.
 * @returns {object} external_identifiers_insert_input
 */
export const buildIdentifierObject = ({ organization_id, clientId, key, label, value }) => ({
    organization_id,
    client_id: clientId,
    key,
    label,
    value: normalizeValue(value),
});
